import { SPINNER } from '../utils/constant';

export function updateSpinnerState(state) {
    return {
        type: SPINNER.STATE,
        state: state
    }
}
